/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-unused-vars */
import { CCollapse } from '@coreui/react';
import {
  BackgroundBannerDefault,
  CTA,
  FooterFrontend,
  Hero,
  LoadingScreen,
  OurClient,
  OurPartner,
  Sidebar,
  WAFixed
} from 'components';
import ResponseErrorServerSide from 'components/ResponseErrorServerSide';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { NavbarCourierServices } from 'parts/courier-services';
import { AboutPage, Devider, OurServices } from 'parts/International-delivery';
import { MainContent } from 'parts/landingpage';
import React, { useEffect, useRef, useState } from 'react';
import { dehydrate, QueryClient } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { setToggle } from 'redux/toggleSlice';
import { FrontendAPI } from 'services';
import { useLoading } from 'utils/useLoading';

export async function getServerSideProps(context) {
  const queryClient = new QueryClient();

  const lang = context?.locale === 'en' ? 'EN' : 'ID';

  // index pertama harus paling atas
  await queryClient.prefetchQuery('product', () =>
    FrontendAPI.getPageBySlug({ slug: 'international-delivery' })
  );

  await queryClient.prefetchQuery('landing-page', () =>
    FrontendAPI.landingPage()
  );

  await queryClient.prefetchQuery('header-footer', () =>
    FrontendAPI.headerFooter()
  );

  await queryClient.prefetchQuery('office-pin-point', () =>
    FrontendAPI.officePinPoint()
  );
  // ===

  const allData = dehydrate(queryClient)?.queries?.map((item) => ({
    module: item.queryKey,
    state: item.state.data.data
  }));

  let result = {
    product: null,
    landingPage: null,
    headerFooter: null,
    coverageArea: null,

    // err
    isError: null
  };

  // if data current page(index 0/get by slug) not found
  if (
    dehydrate(queryClient)?.queries[0]?.state?.data?.message === 'Not Found!'
  ) {
    return {
      notFound: true
      // redirect: {
      //   destination: '/',
      //   permanent: false,
      // },
    };
  }
  // ===

  // onError server
  if (
    !dehydrate(queryClient)?.queries[0]?.state?.data?.success ||
    !dehydrate(queryClient)?.queries[1]?.state?.data?.success ||
    !dehydrate(queryClient)?.queries[2]?.state?.data?.success ||
    !dehydrate(queryClient)?.queries[3]?.state?.data?.success
  ) {
    result.isError = true;
  }

  // onSuccess
  if (dehydrate(queryClient)?.queries[0]?.state?.data?.success) {
    result.product = allData[0];
  }

  if (dehydrate(queryClient)?.queries[1]?.state?.data?.success) {
    result.landingPage = allData[1];
  }

  if (dehydrate(queryClient)?.queries[2]?.state?.data?.success) {
    result.headerFooter = allData[2];
  }

  if (dehydrate(queryClient)?.queries[3]?.state?.data?.success) {
    result.coverageArea = allData[3];
  }

  return {
    props: {
      // getBySlug: dehydrate(queryClient)?.queries[0]?.state?.data,
      // product: allData[0],
      // landingPage: allData[1],
      // headerFooter: allData[2],
      // coverageArea: allData[3],

      ...result,
      lang
    }
  };
}

function InternationalDelivery({
  product,
  landingPage,
  headerFooter,
  coverageArea,
  isError,
  lang
}) {
  const router = useRouter();
  const dispatch = useDispatch();
  // const language = useSelector((state) => state.toggle.language);
  const language = lang;
  const pathname = router.asPath.split('/').pop();

  const [visible, setVisible] = useState(false);
  const prevScrollY = useRef(0);
  const [goingUp, setGoingUp] = useState(false);
  const loading = useLoading(false);

  // seo
  const seo = product?.state;
  // ===

  // navbar
  const navbar = headerFooter?.state?.header;
  // ===

  // banner
  const banner = landingPage?.state?.banner;
  // ===

  // coverageArea
  let CoverageArea = [];
  coverageArea?.state?.forEach((item) => {
    CoverageArea.push(item.jvector_code);
  });
  // ===

  // navigasi menu
  const navigasiMenu = landingPage?.state?.navigationMenu;
  // ===

  // hero
  const newDataHeader = {
    banner_img: product?.state?.banner_img,
    cta_btn_id: product?.state?.cta_btn_id,
    en_desc: product?.state?.en_desc,
    en_title: product?.state?.en_title,
    id_desc: product?.state?.id_desc,
    id_title: product?.state?.id_title,
    headerCTA: product?.state?.headerCTA,
    additional_cta_btn_id: product?.state?.additional_cta_btn_id,
    additionalCTA: product?.state?.additionalCTA
  };
  const dataHero = newDataHeader;
  // ===

  //  about
  const newAbout = {
    en_desc_about: product?.state?.en_desc_about,
    en_img_about: product?.state?.en_img_about,
    en_subtitle_about: product?.state?.en_subtitle_about,
    en_title_about: product?.state?.en_title_about,
    en_alt_img_about: product?.state?.en_alt_img_about,

    id_desc_about: product?.state?.id_desc_about,
    id_img_about: product?.state?.id_img_about,
    id_subtitle_about: product?.state?.id_subtitle_about,
    id_title_about: product?.state?.id_title_about,
    id_alt_img_about: product?.state?.id_alt_img_about
  };
  const dataAbout = newAbout;
  // ===

  // services
  const newProducts = {
    en_service_text: product?.state?.en_service_text,
    id_service_text: product?.state?.id_service_text,
    product: product?.state?.Products
  };
  const dataOurProducts = newProducts;
  // ===

  // client
  const newClient = {
    en_client_text: product?.state?.en_client_text,
    id_client_text: product?.state?.id_client_text,
    client: product?.state?.client
  };
  const dataClient = newClient;
  // ===

  // partner
  const newPartner = {
    id_partner_text: product?.state?.id_partner_text,
    en_partner_text: product?.state?.en_partner_text,
    partner: product?.state?.partner
  };
  const dataPartner = newPartner;
  // ===

  // cta fixed
  const dataCTA = product?.state;
  const newCTAFixed = {
    ...dataCTA?.stickyCTA,
    sticky_cta_btn_id: dataCTA?.sticky_cta_btn_id
  };
  const dataCTAFixed = newCTAFixed;
  // ===

  // section cta
  const newDataCTAsection = product?.state;
  const newDataCTA = newDataCTAsection?.CTAButton;

  const dataCTASection = {
    newDataCTA,
    en_cta_text: newDataCTAsection?.en_cta_text,
    id_cta_text: newDataCTAsection?.id_cta_text
  };
  // ===

  // footer
  const footer = headerFooter?.state?.footer;
  // ===

  useEffect(() => {
    const handleScroll = () => {
      if (typeof window !== 'undefined') {
        const currentScrollY = window.scrollY;
        if (prevScrollY?.current < currentScrollY && goingUp) {
          setGoingUp(false);
        }
        if (prevScrollY?.current > currentScrollY && !goingUp) {
          setGoingUp(true);
        }

        let startY = document.querySelectorAll(
          '.codrops-top-for-page-detail'
        )[0]?.clientHeight;
        prevScrollY.current = currentScrollY;

        //
        if (currentScrollY > startY) {
          let el = document.querySelectorAll('.codrops-top-for-page-detail')[0];

          el?.classList?.add('scrolled');
        } else {
          let el = document.querySelectorAll('.codrops-top-for-page-detail')[0];

          el?.classList?.remove('scrolled');
        }
      }
    };

    if (
      document.querySelectorAll('.codrops-top-for-page-detail')[0]
        ?.clientHeight > 0
    ) {
      if (typeof window !== 'undefined') {
        window.addEventListener('scroll', function () {
          handleScroll();
        });

        window.addEventListener('load', function () {
          handleScroll();
        });

        window.addEventListener('resize', function () {
          handleScroll();
        });
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, [goingUp]);

  const handleChangeLanguage = () => {
    if (language === 'EN') {
      dispatch(setToggle({ language: 'ID' }));
      router.push('/' + pathname, '/' + pathname, { locale: 'id' });
    } else {
      dispatch(setToggle({ language: 'EN' }));
      router.push('/' + pathname, '/' + pathname, { locale: 'en' });
    }
  };

  useEffect(() => {
    // check first load
    if (language === 'ID') {
      dispatch(setToggle({ language: 'ID' }));
    }
    if (language === 'EN') {
      dispatch(setToggle({ language: 'EN' }));
    }
  }, []);

  const topFunction = () => {
    setVisible((currentValue) => !currentValue);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const openNav = () => {
    document.getElementById('mySidenav').style.width = '320px';
  };

  const closeNav = () => {
    document.getElementById('mySidenav').style.width = '0';
  };

  if (loading) return <LoadingScreen />;

  return (
    <>
      {isError && <ResponseErrorServerSide />}

      <NextSeo
        title={
          language === 'ID' ? seo?.id_seo_page_title : seo?.en_seo_page_title
        }
        description={language === 'ID' ? seo?.id_meta_desc : seo?.en_meta_desc}
        additionalMetaTags={[
          {
            property: 'keywords',
            content:
              language === 'ID' ? seo?.id_meta_keyword : seo?.en_meta_keyword
          }
        ]}
        additionalLinkTags={[
          {
            rel: 'canonical',
            href: `${process.env.URL_FRONTEND}${
              language === 'ID' ? seo?.id_slug : seo?.en_slug
            }`
          },
          {
            rel: 'icon',
            href: navbar?.web_icon
          }
        ]}
      />

      <div>
        <CCollapse visible={visible} id="collapse-top-index">
          <div className="card card-body">
            <BackgroundBannerDefault data={banner} language={language} />

            <MainContent
              language={language}
              data={navigasiMenu}
              CoverageArea={CoverageArea}
            />
          </div>
        </CCollapse>

        <div
          id="col-top-nav"
          className="codrops-top codrops-top-for-page-detail"
        >
          <NavbarCourierServices
            topFunction={topFunction}
            data={navbar}
            changeLanguage={handleChangeLanguage}
            language={language}
          />

          <Sidebar
            changeLanguage={handleChangeLanguage}
            closeNav={closeNav}
            openNav={openNav}
            topFunction={topFunction}
            data={navbar}
            language={language}
          />
        </div>

        <div className="col-main-page col-main-page-detail">
          <Hero
            breadcrump={navbar}
            language={language}
            dataHeader={dataHero}
            // data={dataBreadcrump}
          />

          <AboutPage data={dataAbout} language={language} />
          <Devider />

          {dataOurProducts?.product?.length > 0 && (
            <OurServices
              language={language}
              data={dataOurProducts?.product}
              en_service_text={dataOurProducts?.en_service_text}
              id_service_text={dataOurProducts?.id_service_text}
            />
          )}

          {dataClient?.client?.length > 0 && (
            <OurClient
              client={dataClient?.client}
              id_title={dataClient?.id_client_text}
              en_title={dataClient?.en_client_text}
              language={language}
            />
          )}

          {dataPartner?.partner?.length > 0 && (
            <OurPartner
              id_title={dataPartner?.id_partner_text}
              en_title={dataPartner?.en_partner_text}
              language={language}
              partner={dataPartner?.partner}
            />
          )}

          <CTA
            CTAButton={dataCTASection?.newDataCTA}
            language={language}
            id_desc={dataCTASection?.id_cta_text}
            en_desc={dataCTASection?.en_cta_text}
          />
        </div>

        {dataCTAFixed?.sticky_cta_btn_id !== 0 && (
          <WAFixed data={dataCTAFixed} />
        )}
        <FooterFrontend footer={footer} language={language} />
      </div>
    </>
  );
}

export default InternationalDelivery;
